import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=015c2c6a"
import script from "./PromoCodes.vue?vue&type=script&lang=ts"
export * from "./PromoCodes.vue?vue&type=script&lang=ts"
import style0 from "./PromoCodes.vue?vue&type=style&index=0&id=015c2c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports